<template>
    <article class="homepage page type-page status-publish hentry">

        <!--<div class="header-container">-->
        <div class="container">
            <header class="entry-header" style="position: absolute; width: 100%;">
                <h1 class="entry-title">We make things<br>look good.</h1>
                <p class="more"><router-link to="/work" title="Take a peek">Take a peek</router-link></p>
            </header><!-- .entry-header -->

            <div id="video-container" >

                <!--<img src="https://media.giphy.com/media/LNE01Z89j9gis/giphy.gif" alt="" style="position: absolute; width: auto; height: 100%; max-width: initial !important;">-->
                <video id="is-video" muted v-if="!isMobile" autoplay="autoplay" class="video-element"  preload="auto" loop width="1160" height="652" poster="/video/poster.jpg" webkit-playsinline>
                    <source src="/video/alt.mp4" align="right" type="video/mp4"></source>
                </video>
                <div class="mobile-video" v-if="isMobile" alt="intro video"></div>

            </div>
        </div>

        <div class="entry-content">

            <div class="homepage-grid">
                <div class="row">
                    <div class="left stack">
                        <div class="top animateIn">
                            <div class="text">
                                <h2 class="title">We’re a friendly bunch, down-to-earth and honest. We pride ourselves on long lasting client relationships.</h2>
                                <p class="more"><router-link to="/about">Take a peek</router-link></p>
                            </div>
                        </div>
                        <div class="bottom animateIn">
                            <router-link to="/work/simpson-marine" v-lazy:background-image="$store.state.url + '/assets/images/simpson.png'" class="block whitePeak" :style="{ backgroundColor: '#FFFFFF', color: '#2E2E2E' }">
                                <p class="sector">Work</p>
                                <h2 class="title">Simpson Marine</h2>
                            </router-link>
                        </div>
                    </div>
                    <div class="right animateIn">
                        <router-link to="/work/shipping-building" v-lazy:background-image="$store.state.url + '/assets/images/shipping_building.png'" class="block cabyn" :style="{ backgroundColor: '#EBEBED', color: '#3D392E' }">
                            <p class="sector">Work</p>
                            <h2 class="title">Shipping Building</h2>
                        </router-link>
                    </div>
                </div>
                <div class="row stack">
                    <div class="left wide animateIn">
                        <router-link to="/work/golfing-days" v-lazy:background-image="$store.state.url + '/assets/images/golfing-days.gif'" class="block neo" :style="{ backgroundColor: '#323B3C', color: '#FFFFFF' }">
                            <p class="sector">Work</p>
                            <h2 class="title">Golfing Days</h2>
                        </router-link>
                    </div>
                    <div class="right narrow animateIn">
<!--                        <instagram token="342966648.399e149.e4c47ff92e2642768aa1bef3e6cf8148" username="_altdesign" :count="2"></instagram>-->
<!--                      <instagram token="IGQVJWWkMzRDF2dGlmRURMOVlqSlduZAnhZASkYzX040X0pjSkh5cUg4eTFpRVZAwZAmE5ZAXhVSVZAad1RpXzltR0NiT1otbDhkZATFWeThCUzNDZAVJpVzNwaVRZAOXdDS2V5ZA2Fkejg5UTNnSXNDMTI5VFVFcwZDZD" username="_altdesign" :count="2"></instagram>-->
                      <instagram :token="instaToken" username="_altdesign" :count="2"></instagram>
                    </div>
                </div>
                <div class="row">
                    <div class="left ">
                        <router-link to="/work/hannells" v-lazy:background-image="$store.state.url + '/assets/images/hannells.png'" class="block black joanie medium animateIn" :style="{ backgroundColor: '#FFD008', color: '#000000' }">
                            <p class="sector">Work</p>
                            <h2 class="title">Hannells</h2>
                        </router-link>
                        <router-link to="/work/invest-in-derbyshire" v-lazy:background-image="$store.state.url + '/assets/images/invest_in_derbyshire.gif'" class="block robinson medium animateIn" :style="{ backgroundColor: '#C3CF27', color: '#FFFFFF' }">
                            <p class="sector">Work</p>
                            <h2 class="title">Invest in Derbyshire</h2>
                        </router-link>
                    </div>
                    <div class="right animateIn">
                        <router-link to="/work/sea-lng" v-lazy:background-image="$store.state.url + '/assets/images/sea_lng.png'" class="block princess tall" :style="{ backgroundColor: '#85BFD9', color: '#FFFFFF' }">
                            <p class="sector">Work</p>
                            <h2 class="title">Sea LNG</h2>
                        </router-link>
                    </div>
                </div>
            </div>

            <div class="social-buttons animateIn">
                <ul>
                    <h2 class="title">Follow us!</h2>
                    <li class="facebook"><a href="https://www.facebook.com/altdesignderby/" target="_blank" title="Find us on Facebook"><span class="icon-facebook"></span></a></li>
                    <li class="twitter"><a href="https://twitter.com/_altdesign" target="_blank" title="Follow us on Twitter"><span class="icon-twitter"></span></a></li>
                    <li class="instagram"><a href="https://www.instagram.com/_altdesign/" target="_blank" title="Follow us on Instagram"><span class="icon-instagram"></span></a></li>
                </ul>
            </div>
        </div>


    </article>

</template>

<script>
  export default {
    data () {
      return {
        isMobile: true,
        instaToken: ''
      }
    },
    methods: {
      checkForMobile () {
        this.isMobile = window.innerWidth < 600
      }
    },
    mounted () {
      this.checkForMobile()
      window.addEventListener('resize', () => {
        this.checkForMobile()
      })
      document.getElementById('is-video').play()
    },
    created () {
      window.api.get('get-pages-by-type/2').then(res => {
        this.projects = res.data.data
      }).then(() => {
        this.$setTweens()
      })

      window.api.get('get-insta').then(res => {
        this.instaToken = res.data
      })
      this.$setSeo('Graphic Design Agency / Web Design / Brand Consultants Midlands | Alt Design', 'Based in Derby, Alt Design are one of the top graphic design agencies in the Midlands specialising in branding, print, and web design. Call us on 01332 208733.')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Pages/Homepage.vue